export default __webpack_public_path__ + "static/media/CountPage2.2605e9ab.txt";